import type { ComponentProps } from 'react';

import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { twMerge } from 'tailwind-merge';
import { tv, type VariantProps } from 'tailwind-variants';

const separatorVariants = tv({
  base: 'shrink-0',
  variants: {
    bg: {
      gray: 'bg-foreground/10',
      transparent: 'bg-transparent',
    },
    orientation: {
      horizontal: 'h-px w-full',
      vertical: 'h-full w-px',
    },
  },
  defaultVariants: {
    bg: 'gray',
    orientation: 'horizontal',
  },
});

interface SeparatorProps
  extends Omit<ComponentProps<typeof SeparatorPrimitive.Root>, 'color' | 'orientation'>,
    VariantProps<typeof separatorVariants> {}

export function Separator({
  className,
  children,
  asChild,
  bg,
  orientation,
  decorative = true,
  ...props
}: SeparatorProps): React.ReactElement {
  return (
    <SeparatorPrimitive.Root
      decorative={decorative}
      orientation={orientation}
      className={separatorVariants({
        ...props,
        orientation: asChild ? undefined : orientation,
        bg: asChild ? 'transparent' : bg,
        className: twMerge(className, asChild ? 'w-fit h-fit' : ''),
      })}
      {...props}
    >
      {children}
    </SeparatorPrimitive.Root>
  );
}
